import { z } from "zod";

export const NotificationBaseSchema = z.object({
  groupe_id: z.number().int().positive("L'ID du groupe doit être un nombre positif").nullable().optional(),
  type: z.string().min(1, "Le type est requis").max(255, "Le type ne peut pas dépasser 255 caractères"),
  statut: z.number().int().nullable().optional(),
});

export const NotificationSchema = NotificationBaseSchema.extend({
  id: z.number().int().positive(),
  created_at: z.date().nullable().optional(),
  updated_at: z.date().nullable().optional(),
});

export const NotificationCreateSchema = NotificationBaseSchema.pick({
  groupe_id: true,
  type: true,
  statut: true,
});

export const NotificationUpdateSchema = z.object({
  id: z.number().int().positive(),
  groupe_id: z.number().int().positive("L'ID du groupe doit être un nombre positif").nullable().optional(),
  type: z.string().min(1, "Le type est requis").max(255, "Le type ne peut pas dépasser 255 caractères").optional(),
  statut: z.number().int().nullable().optional(),
});

export const NotificationListResponseSchema = z.object({
  data: z.array(NotificationSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});

export const NotificationResponseSchema = z.object({
  data: NotificationSchema,
  message: z.string().optional(),
});

export const NotificationSelectSchema = z.object({
  id: z.number().int().positive().optional(),
  groupe_id: z.number().int().positive().optional(),
  type: z.string().optional(),
  statut: z.number().int().optional(),
});

export type Notification = z.infer<typeof NotificationSchema>;
export type NotificationCreateInput = z.infer<typeof NotificationCreateSchema>;
export type NotificationUpdateInput = z.infer<typeof NotificationUpdateSchema>;
export type NotificationSelectInput = z.infer<typeof NotificationSelectSchema>;

// Form-specific types for frontend
export type NotificationFormData = NotificationCreateInput;

export type NotificationEditFormData = Omit<NotificationUpdateInput, 'id'>;

// Utility types for different UI states
export type NotificationDisplayItem = Pick<Notification, 'id' | 'type' | 'statut' | 'created_at'>;
export type NotificationSelectOption = Pick<Notification, 'id' | 'type'>;
export type NotificationTableItem = Pick<Notification, 'id' | 'groupe_id' | 'type' | 'statut' | 'created_at' | 'updated_at'>;

export type NotificationResponse = z.infer<typeof NotificationResponseSchema>;
export type NotificationListResponse = z.infer<typeof NotificationListResponseSchema>;

export const validateNotificationCreate = (data: unknown) => {
  return NotificationCreateSchema.safeParse(data);
};

export const validateNotificationUpdate = (data: unknown) => {
  return NotificationUpdateSchema.omit({ id: true }).safeParse(data);
};

export const validateNotificationSelect = (data: unknown) => {
  return NotificationSelectSchema.safeParse(data);
};
